<template>
    <div class="pageBody">
        <i-table border :loading="tableLoading" :columns="columns" :data="tableList" @on-selection-change="selectChange"
            ref="table" :height="tableHeight"></i-table>
        <div class="pageBottom" v-if="needNext">
            <div class="pageLoading" v-if="loading">
                <Icon type="load-a" size="15"></Icon>
            </div>
            <div class="nextPage" v-else-if="haveNext" @click="nextPage">{{ $t("common.nextPage") }}</div>
            <div class="pageNone" v-else>{{ $t("common.pageNone") }}</div>
        </div>
        <!-- <div class="pageInfo">
            <div class="pageTxt">
                {{ pageInfo }}
            </div>
            <div class="pageSize">
                <i-select v-model="size" style="width: 120px">
                    <i-option :value="size">{{ $t("common.pageSize").replace('{num}', size) }}</i-option>
                    <i-option :value="item" v-for="(item, index) in pageSizeList" :key="index">{{
                        $t("common.pageSize").replace('{num}', item) }}</i-option>
                </i-select>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    props: {
        page: {
            type: Object,
            default() {
                return undefined
            }
        },
        type: {
            type: Number,
            default: 1
        },
        columns: {
            type: Array,
            default() {
                return [];
            }
        },

        //查询table的类型
        queryTableType: {
            type: Number,
            default: 0,
        },
        //table的查询参数
        queryTableParam: {
            type: Object,
            default() {
                return {};
            },
        },
        //查询table的方法
        queryTableFunc: {
            type: Function,
            default() {
                return undefined;
            }
        },
        //查询table的api
        queryTableApi: {
            type: Function,
            default() {
                return undefined;
            }
        },
        //是否初始化加载
        isInitRender: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            total: 0,
            current: 1, // 当前页码
            size: 999, // 每页个数
            maxCurrent: 1,
            needNext: false, //需要显示下一页内容时 滚动到底部 触发
            haveNext: false, //可以加载下一页数据
            loading: false, // 加载中
            chudiNoneData: false,
            t: undefined,
            hideT: undefined,
            scrollT: undefined,
            lastScroll: 0,

            tableLoading: false,
            tableList: [],
            selectList: [],
            tableHeight: 100,

            // pageSizeList: [40, 100, 200, 999]
        };
    },
    created() {
        if (this.page) {
            this.size = this.page.size;
            this.current = this.page.current;
            this.total = this.page.total || 0;
        }
        if (this.isInitRender)
            this.refrushTable();
    },
    computed: {
        pageInfo() {
            console.log(this.total);
            return this.$t("common.pageInfo").replace("{now}", this.current).replace("{all}", this.maxCurrent).replace("{allNum}", this.total);
        }
    },
    methods: {
        getGuid() {
            var guid = "";
            for (var i = 1; i <= 32; i++) {
                var n = Math.floor(Math.random() * 16.0).toString(16);
                guid += n;
                if ((i == 8) || (i == 12) || (i == 16) || (i == 20)) guid += "-";
            }
            return guid;
        },
        /**
         * 设置总页码数
         * @param {Numebr} v 总页码数量
         */
        setTotal(v) {
            this.total = v;
            let maxCurrent = (Math.floor(this.total / this.size) + (this.total % this.size > 0 ? 1 : 0)) || 1;
            if (this.current < maxCurrent) {
                this.haveNext = true;
                this.chudiNoneData = false;
            }
            else {
                this.current = maxCurrent;
                this.chudiNoneData = true;
            }
            this.maxCurrent = maxCurrent;
            this.lastScroll = 0;
            this.loading = false;
            this.needNext = false;
            clearTimeout(this.hideT);
            clearTimeout(this.scrollT);
            clearTimeout(this.t);
            this.hideT = undefined;
            this.scrollT = undefined;
            this.t = undefined;
        },
        setCurrent(v) {
            this.current = v;
        },
        setSize(v) {
            this.size = v;
        },
        setData(v) {
            this.tableList = v;
        },
        hideLoading() {
            this.loading = false;
        },
        scrollChange(e) {
            let elem = e.srcElement;
            if (this.scrollT || elem.scrollTop == 0)
                return;
            if (this.lastScroll != 0) {
                if (this.lastScroll >= elem.scrollTop) {
                    this.lastScroll = elem.scrollTop;
                    return;
                }
            }
            this.lastScroll = elem.scrollTop;

            let v = elem.scrollTop + elem.offsetHeight - elem.scrollHeight;
            if (v <= 50 && v >= -50) {
                if (this.needNext)
                    return;
                this.scrollT = setTimeout(() => {
                    if (!this.loading && !this.chudiNoneData) {
                        this.needNext = true;
                        e.srcElement.scrollTop = e.srcElement.scrollTop - 50;
                        if (this.type == 1) {
                            if (this.haveNext) {
                                this.nextPage();
                            } else {
                                setTimeout(() => {
                                    this.hideLoading();
                                }, 1000);
                            }
                        }
                        this.loading = true;
                    } else {
                        this.needNext = false;
                    }
                }, 50);
            }
        },
        nextPage() {
            if (this.t) {
                return;
            }
            if (this.haveNext && !this.loading) {
                this.t = setTimeout(async () => {
                    this.current++;
                    await this.concatTable();
                    this.t = undefined;
                    this.scrollT = undefined;
                }, 100);
            }
        },

        /**
         * 去查询表数据
         */
        async queryTable() {
            const _page = {
                pageSize: this.size,
                pageIndex: this.current
            };
            let result = undefined;
            switch (this.queryTableType) {
                case 0:
                    {
                        const res = await this.queryTableFunc(_page);
                        result = res;
                    }
                    break;
                case 1:
                    {
                        const res = await this.queryTableApi({ ..._page, ...this.queryTableParam });
                        if (res.code == 200) {
                            result = {
                                data: res.data,
                                total: res.totalCount
                            };
                        } else
                            this.$Message.error("查询失败");
                    }
                    break;
                default:
                    break;
            }
            //使滚动条回归初始值
            this.$refs.table.$el.querySelector('.ivu-table-body').scrollLeft = 0;
            return result;
        },
        //刷新表数据
        async refrushTable() {
            this.tableHeight = 100;
            this.tableLoading = true;
            this.tableList = [];
            this.selectList = [];
            if (this.$refs.table)
                this.$refs.table.$el.querySelector('.ivu-table-body').scrollTop = 0;
            this.setTotal(0);
            const result = await this.queryTable();
            if (result) {
                result.data.forEach(c => c._tableRowId = this.getGuid());
                this.tableList = result.data;
                this.setTotal(result.total);
            }
            this.tableLoading = false;
            this.$nextTick(() => {
                this.tableHeight = document.querySelector('.pageBody').clientHeight - 50;
                this.$refs.table.$el.querySelector('.ivu-table-body').onscroll = this.scrollChange;
            });
        },
        /**
         * 追加表数据
         */
        async concatTable() {
            this.tableLoading = true;
            const result = await this.queryTable();
            if (result) {
                result.data.forEach(c => c._tableRowId = this.getGuid());
                this.tableList.forEach(c => {
                    if (this.selectList.some(a => a._tableRowId == c._tableRowId))
                        c._checked = true;
                });
                this.tableList = this.tableList.concat(result.data);
                this.setTotal(result.total);
            }
            this.tableLoading = false;
        },
        /**
         * 重载表数据 到当前的页码
         * @param {Boolean} isTop 是否回归到滚动条顶端
         */
        async reloadTable(isTop) {
            const scrollTop = this.$refs.table.$el.querySelector('.ivu-table-body').scrollTop;
            const page = {
                size: this.size,
                current: this.current
            };
            this.size = this.size * this.current;
            this.current = 1;
            await this.refrushTable();
            this.size = page.size;
            this.current = page.current;
            this.setTotal(this.total);
            if (!isTop)
                this.$refs.table.$el.querySelector('.ivu-table-body').scrollTop = scrollTop;
        },
        /**
         * 移除行
         * @param {Number} index 下标
         * @param {Number} count 数量
         */
        removeRow(index, count) {
            this.tableList.splice(index, count);
            this.total -= count;
            this.setTotal(this.total);
        },
        /**
         * 行选中事件
         * @param {*} e 
         */
        selectChange(e) {
            this.selectList = e;
        },
        /**
         * 获取选中的项的集合
         */
        getSelect() {
            return this.selectList;
        }
    }, watch: {
        selectList(v, ov) {
            this.$emit("selectTable", v.length == ov.length ? [] : v, this.tableList);
        },
        size(v, ov) {
            this.refrushTable();
        }, loading(v) {
            if (v)
                this.tableHeight = this.tableHeight - 50;
            else
                this.tableHeight = this.tableHeight + 50;
        }
    }
}
</script>
<style lang="scss" scoped>
.pageBody {
    height: 100%;
    position: relative;
}

.pageInfo {
    text-align: center;
    font-size: 15px;
    color: #999;
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .pageTxt {
        margin: 0 20px;
    }
}

.pageBottom {
    width: 100%;
    text-align: center;
    border-radius: 20px;
    min-height: 50px;

    .pageLoading {
        padding: 10px 0px;
        background-color: white;
    }

    .nextPage {
        cursor: pointer;
    }

    .nextPage,
    .pageNone {
        padding: 10px 0px;
        font-size: 18px;
    }
}

.ivu-icon-load-a::before {
    content: "\F45B";
}

.ivu-icon-load-a {
    animation: iRun 2s linear infinite;
}

@keyframes iRun {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/deep/ .ivu-table-wrapper {
    height: calc(100% - 50px);
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/view/homeManage/PageScroll.vue